import React from 'react'
import PropTypes from 'prop-types'

import { formatNumberToShort } from '../../../../../helpers'
import { useCustomAxisStyles } from './styles'

// Custom HTML axis component to stay fixed outside the scrollable canvas area.
const CustomAxis = ({ color, maxValue, position, currencySymbol = '', chartAreaDimensions = null }) => {
  // Align the axis width with the chart's plotting area (excluding Y-axis label space)
  const classes = useCustomAxisStyles({ color, position, chartAreaDimensions })

  // Generate 5 evenly spaced tick marks
  const generateTicks = () => {
    const numTicks = 5
    const ticks = []
    const step = maxValue / (numTicks - 1)

    for (let i = 0; i < numTicks; i++) {
      const value = Math.round(step * i)

      // Format using helper function
      let label = formatNumberToShort(value, 0)

      // Add currency for top axis
      if (position === 'top' && currencySymbol) {
        label = currencySymbol + label
      }

      ticks.push({ value, label })
    }

    return ticks
  }

  const ticks = generateTicks()

  return (
    <div className={classes.axisContainer}>
      <div className={classes.scaleContainer}>
        <div className={classes.scaleLine} />
        {ticks.map((tick, index) => (
          <div key={index} className={classes.scaleMarker}>
            <div className={classes.tick} />
            <div className={classes.tickLabel}>{tick.label}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

CustomAxis.propTypes = {
  color: PropTypes.string.isRequired,
  maxValue: PropTypes.number.isRequired,
  position: PropTypes.oneOf(['top', 'bottom']).isRequired,
  currencySymbol: PropTypes.string,
  chartAreaDimensions: PropTypes.shape({
    left: PropTypes.number,
    right: PropTypes.number,
    width: PropTypes.number
  })
}

export default CustomAxis
